import { RESOURCE_NAME as GUEST_EFSES } from '@esentai/core/features/guestEfs/consts';
import { permit } from '@esentai/core/policy-dsl';

import { GUEST_EFS } from '@/features/guestEfsPage/consts/permissions';

export default [permit(GUEST_EFSES, [GUEST_EFS])];
